var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "col-5" },
      [
        _c("list-user", {
          attrs: {
            name: "userTarget",
            block: _vm.searchingApprovals,
            label: "Usuario a reemplazar"
          },
          model: {
            value: _vm.userTarget,
            callback: function($$v) {
              _vm.userTarget = $$v
            },
            expression: "userTarget"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-5" },
      [
        _c("list-user", {
          ref: "userStep",
          attrs: {
            name: "userSubstitute",
            block: false,
            label: "Usuario que reemplaza"
          },
          model: {
            value: _vm.userSubstitute,
            callback: function($$v) {
              _vm.userSubstitute = $$v
            },
            expression: "userSubstitute"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-2 text-center" },
      [
        _c(
          "b-button",
          {
            staticClass: "mt-5",
            attrs: { variant: "primary" },
            on: { click: _vm.saveSubstitutions }
          },
          [_vm._v(" Guardar ")]
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-12 mt-3" },
      [
        _c(
          "b-overlay",
          { attrs: { show: _vm.searchingApprovals } },
          [
            _vm.userTargetApprovals.length
              ? _c("h4", [
                  _vm._v(
                    " Selecciona los flujos en los que deseas aplicar el reemplazo "
                  )
                ])
              : _vm._e(),
            _vm.userTargetApprovals.length
              ? _c("div", { staticClass: "my-4 text-primary" }, [
                  _c(
                    "div",
                    { staticClass: "text-primary d-inline" },
                    [
                      _c("b-form-checkbox", {
                        staticClass: "d-inline-block",
                        on: { change: _vm.selectAllFlows },
                        model: {
                          value: _vm.selectAll,
                          callback: function($$v) {
                            _vm.selectAll = $$v
                          },
                          expression: "selectAll"
                        }
                      }),
                      _vm._v(" Seleccionar todos ")
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.userTargetApprovals.length
              ? _c("header-substitutions")
              : _vm._e(),
            _vm._l(_vm.userTargetApprovals, function(file) {
              return _c("row-substitutions", {
                key: file.idAprobacion,
                attrs: { file: file },
                on: {
                  "select-flow": _vm.selectFlow,
                  "unselect-flow": _vm.unSelectFlow
                }
              })
            })
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", { staticClass: "text-primary mb-5 text-center" }, [
        _vm._v(
          " Cuando selecciones el usuario a reemplazar, se listarán los flujos de aprobaciones en los que esté participando "
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }